import styled from 'styled-components';

export const StyledFormError = styled.div`
    color: #D33A2C;
    margin-top: -12px;
    font-size: 13px;
`
